var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-links"},_vm._l((_vm.socialLinks),function(h,i){return _c('button',{key:i,staticClass:"circleBtn",attrs:{"title":h.title}},[_c('a',{attrs:{"href":h.link,"target":"_blank"}},[_c('div',{style:('color:' + h.color),domProps:{"innerHTML":_vm._s(h.tag)}})])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b46401e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialHandlers.vue
// module id = Q1WI
// module chunks = 0